import PropTypes from "prop-types"
import React from "react"

import DiscountItem from "./DiscountItem"
import PricingItem from "./PricingItem"

const Discounted = props => {
  const { plan, lang } = props
  const { discount } = plan

  return (
    <div className="flex-container f-a-center f-j-center m-t-25">
      <div className="flex-container f-d-col">
        <DiscountItem
          priceToPay={discount.priceToPay}
          isFree={discount.isFree}
          duration={discount.type.duration}
          unit={discount.type.unit}
          currency={discount.price.currency}
          priceBeforeDiscount={plan.price.net_amount}
          lang={lang}
        />
        <PricingItem
          discountDuration={discount.type.duration}
          discountPeriodUnit={discount.type.unit}
          subscriptionPeriod={plan.subscription_period}
          isDiscountApplied={plan.isDiscountApplied}
          price={plan.price}
          lang={lang}
        />
      </div>
    </div>
  )
}

Discounted.propTypes = {
  plan: PropTypes.object,
  lang: PropTypes.string,
}
Discounted.defaultProps = { plan: {}, lang: "en" }

export default Discounted
